<template>
  <div>
    <div class="row">
      <template v-if="editing">
        <div class="col-3">
          <WeekSelect :config="config"/>
        </div>
        <div class="col-3">
          <label for="title-planning">{{ $t('ui.title')}}</label>
          <input type="text" id="title-planning" class="form-control" v-model="config.title">
        </div>
      </template>
    </div>

    <template v-if="!editing">
      <WeekSelect :config="config"/>
    </template>
    <div class="chart-container ">
      <bar-chart

          style="width: 100%;height: 100%"
          :chartData="getChartData"
          :options="getOptions"/>
    </div>
  </div>


</template>

<script>
import {mapGetters} from "vuex";

import WeekSelect from "@/components/insights/forms/WeekSelect";
import BarChart from '@/components/insights/charts/barChart.js'

import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import chartColors from "@/mixins/insights/chartColors";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  components: {
    WeekSelect,
    BarChart
  },
  mixins: [timeCalc, generalMethods, chartColors],
  props: ['editing'],
  data() {
    return {
      jobs: [],
      config: {
        weekDifference: 0
      }
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims']),
    getJobs() {
      return this.jobs
    },
    getOptions() {
      const self = this
      return {
        ...this.generalChartOptions,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },
              // bounds: 'ticks',
              offset: true, // IF this is set to false, it will not display the last bar!
              stacked: true,
              type: 'time',
              autoSkip: false,
              startAt: 0,
              time: {
                unit: 'day',
                round: 'day',
                displayFormats: {
                  day: 'DD MMM'
                }
              }
            },
          ],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              stepSize: ((1000 * 60 * 60)) * 5,
              callback: function (label, index, labels) {
                return self.getHoursFromMilliseconds(label, false) + ' hour(s)'
              }
            }
          }],
        },
        tooltips: {
          callbacks: {
            title: function (tooltip) {
              return moment(tooltip[0].label).format('DD MMM')
            },
            label: function (tooltipItem) {
              return self.formattedColonTime(tooltipItem.value) + ' hour(s)'   //tooltipItem.value
            }
          }
        },
        plugins: {
          datalabels: {
            color: 'black',
            anchor: 'start',
            align: 'bottom',
            font: {
              // weight: 'bold',
              size: 20
            },
            offset: -50,

            display: function (ctx) {
              return false
              return ctx.datasetIndex >   0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {
              return self.getHoursFromMilliseconds(value.y, false) > 0    ? self.getHoursFromMilliseconds(value.y, false) + '' : ' '
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    },
    calculatedTarget() {
      const plannedTarget = _.chain(this.getJobsGrouppedOnPlannedDate).map((job, id) => ({
        date: id,
        t: id,
        y: _.sumBy(job, j => {
          return !j.finishedDate ? j.target : 0
        }),
      })).value()

      const plannedTimeSpentFinishedUnderTarget = _.chain(this.getJobsGrouppedOnPlannedDate).map((job, id) => ({
        date: id,
        t: id,
        y: _.sumBy(job, (j) => {
          let timeSpent = j.timeSpent ? j.timeSpent : 0
          let downTimePlanned = j.downTimeTotalPlanned ? j.downTimeTotalPlanned : 0
          let actual = timeSpent - downTimePlanned
          return actual < j.target ? actual : j.target
        }),
      }))
          .value()
      const plannedTimeSpentFinishedOverTarget = _.chain(this.getJobsGrouppedOnPlannedDate).map((job, id) => ({
        date: id,
        t: id,
        y: _.sumBy(job, (j) => {
          let timeSpent = j.timeSpent ? j.timeSpent : 0
          let downTimePlanned = j.downTimeTotalPlanned ? j.downTimeTotalPlanned : 0
          let actual = timeSpent - downTimePlanned
          return actual > j.target ? actual - j.target : 0
        }),
        type: 'overtarget'
      })).value()
      return [plannedTarget, plannedTimeSpentFinishedUnderTarget, plannedTimeSpentFinishedOverTarget]
    },
    getJobsGrouppedOnPlannedDate() {
      return _.groupBy(this.getJobs, job => {
        return job.plannedDate.toDate()
      })
    },
    getChartData() {
      return {
        labels: [],
        datasets: [
          {
            label: this.$t('insights.planning.plannedTarget'),
            backgroundColor: this.colors.planning.target,
            data: this.calculatedTarget[0] ? this.calculatedTarget[0] : [0],
            stack: 'Stack 0',
          },
          {
            stack: 'Stack 1',
            label: this.$t('insights.planning.timeSpent'),
            backgroundColor: this.colors.planning.timeSpent,
            data: this.calculatedTarget[1] ? this.calculatedTarget[1] : [0],

          },
          {
            stack: 'Stack 1',
            label: this.$t('insights.planning.overTime'),
            backgroundColor: this.colors.planning.overTime,
            data: this.calculatedTarget[2] ? this.calculatedTarget[2] : [0],

          }
        ]
      }
    },
  },
  methods: {
    async getJobsFromFilter() {
      let userClaims = this.getClaims

      let time = moment().startOf('week').add(parseInt(this.config.weekDifference), 'week')
      try {
        let jobs = (await this.$FBClient.firestore().collection('jobs')
            .where('companyId', '==', userClaims.companyId)
            .where('plannedDate', '>=', time.toDate())
            .where('plannedDate', '<=', time.endOf('week').toDate())
            .get()).docs.map(doc => {
          return doc.data()
        })
        this.jobs = jobs

      } catch (e) {

      }
      return false
    }

  },
  watch: {
    'config.weekDifference'() {
      this.getJobsFromFilter()
    }
  },
  async created() {
    await this.getJobsFromFilter()

  }
}
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/insights/_generalStylingCharts.scss";


</style>